import { render, staticRenderFns } from "./TargetNote.vue?vue&type=template&id=6c6b6ed2"
import script from "./TargetNote.vue?vue&type=script&lang=js"
export * from "./TargetNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports